const INITIAL_STATE = {
  userCode: '',
  paramVideo: {
    publico: '',
    tag: '',
    titulo: '',
    page: '',
    size: ''
  },
  videos: [],
  tags: [],
  tagSelected: null,
  titleSelected: null,
  publicos: [],
  publicoSelected: null,
  pageVideo: 1,
  publicoFromHome: false,
  videoTags: [],
  revenda_cod: null,
  openModalHome: false,
}

export default function trainingReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_USER_CODE':
      return {
        ...state,
        userCode: action.userCode
      }
    case 'SET_PARAM_VIDEO': 
      return {
        ...state,
        paramVideo: {
          publico: action.publico ? action.publico : '',
          tag: action.tag ? action.tag : '',
          titulo: action.titulo ? action.titulo : '',
          page: action.page ? action.page : '',
          size: action.size ? action.size : ''
        }
      }
    case 'SET_VIDEOS': 
      return {
        ...state,
        videos: action.videos
      }
    case 'SET_TAGS': 
      return {
        ...state,
        tags: action.tags
      }
    case 'SET_TAG_SELECTED': 
      return {
        ...state,
        tagSelected: action.tagSelected
      }
    case 'SET_TITLE_SELECTED': 
      return {
        ...state,
        titleSelected: action.titleSelected
      }
    case 'SET_PUBLICOS': 
      return {
        ...state,
        publicos: action.publicos
      }
    case 'SET_PUBLICO_SELECTED': 
      return {
        ...state,
        publicoSelected: action.publicoSelected
      }
    case 'SET_PAGE_VIDEO': 
      return {
        ...state,
        pageVideo: action.page
      }
    case 'SET_PUBLICO_FROM_HOME':
      return {
        ...state,
        publicoFromHome: action.publicoFromHome
      }
    case 'SET_VIDEO_TAGS': 
      return {
        ...state,
        videoTags: action.videoTags
      }
    case 'SET_TRAINING_STORE': 
      return {
        ...state,
        revenda_cod: action.revenda_cod
      }
    case 'SET_MODAL_HOME': 
      return {
        ...state,
        openModalHome: action.openModalHome
      }
    default:
      return state;
  }
}
